import {
  getItemContentTypeId,
  getItemStatusId,
  getReferenceValue,
  AUTHOR_PROMOTE_CONTENT_TYPES
} from '.';
import { ItemStatus } from '../enums/ItemStatus';
import { useSelector } from './useSelector';

export const useIsAuthorPromotable = () => {
  return useSelector(s => {
    const data = s.form?.data;
    const actionEmployeeId =
      s.view?.actingAs?.props?.empCd || s.app?.user?.employeeId;
    const contentTypeId = getItemContentTypeId(data);
    return (
      AUTHOR_PROMOTE_CONTENT_TYPES.includes(contentTypeId) &&
      getItemStatusId(data) === ItemStatus.Concept_Review &&
      getReferenceValue<number>(data, 'author', 'empCd') === actionEmployeeId
    );
  });
};
